import { Link } from 'react-router-dom'
import { PrivacyContent } from './PrivacyContent'

export default function PrivacyPage() {
  return (
    <div className="legal-doc min-h-screen bg-white py-10">
      <div className="max-w-3xl mx-auto px-6">

        {/* Header */}
        <div className="mb-8 pb-6 border-b-2 border-brand-text">
          <p className="text-xs uppercase tracking-widest text-brand-text-muted mb-2">
            RegenerAI — Documento Legal
          </p>
          <h1 className="text-3xl font-bold text-brand-text mb-2">
            Política de Privacidade
          </h1>
          <p className="text-sm text-brand-text-secondary">
            Versão 1.1 — Última atualização: 14 de abril de 2026
          </p>
        </div>

        {/* Preamble */}
        <p className="text-sm text-brand-text-secondary mb-8 leading-relaxed border-l-4 border-brand-border pl-4">
          Este documento descreve como o RegenerAI coleta, utiliza, armazena e protege seus
          dados pessoais em conformidade com a Lei Geral de Proteção de Dados
          (LGPD — Lei nº 13.709/2018).
        </p>

        {/* Content */}
        <PrivacyContent />

        {/* Footer */}
        <div className="mt-12 pt-6 border-t border-brand-border">
          <p className="text-xs text-brand-text-muted mb-6 leading-relaxed">
            Esta política foi elaborada em conformidade com a Lei nº 13.709/2018 (LGPD) e demais
            normas expedidas pela Autoridade Nacional de Proteção de Dados (ANPD).
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/terms" className="btn-secondary text-center">
              Termos de Uso
            </Link>
            <Link to="/register" className="btn-primary text-center">
              Voltar para Cadastro
            </Link>
          </div>
        </div>

      </div>
    </div>
  )
}
